"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCyTitle = exports.dataCyActionCheckbox = exports.dataCyAction = exports.dataCy = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _hooksTs = require("@gogame/hooks-ts");
var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));
var _Box = _interopRequireDefault(require("../Box"));
var _Icon = require("../Icon");
var _ListItem = _interopRequireDefault(require("../ListItem/ListItem"));
var _ListItemIcon = _interopRequireDefault(require("../ListItemIcon/ListItemIcon"));
var _ListItemSecondaryAction = _interopRequireDefault(require("../ListItemSecondaryAction"));
var _ListItemText = _interopRequireDefault(require("../ListItemText/ListItemText"));
var _Stack = _interopRequireDefault(require("../Stack/Stack"));
var _Typography = _interopRequireDefault(require("../Typography/Typography"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["marginLeft"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var dataCy = exports.dataCy = 'virtualized-list-row';
var dataCyTitle = exports.dataCyTitle = 'virtualized-list-row-title';
var dataCyAction = exports.dataCyAction = 'virtualized-list-row-action';
var dataCyActionCheckbox = exports.dataCyActionCheckbox = 'virtualized-list-row-action-checkbox';
var RowItem = function RowItem(_ref) {
  var label = _ref.label,
    rowHeight = _ref.rowHeight,
    secondaryAction = _ref.secondaryAction,
    actionCount = _ref.actionCount,
    icon = _ref.icon,
    checkbox = _ref.checkbox,
    checked = _ref.checked,
    secondaryLabel = _ref.secondaryLabel,
    isAllChecked = _ref.isAllChecked,
    groupItem = _ref.groupItem,
    count = _ref.count,
    button = _ref.button,
    selected = _ref.selected,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? {
      expanded: false
    } : _ref$state,
    _ref$style = _ref.style,
    _ref$style2 = _ref$style === void 0 ? {} : _ref$style,
    marginLeft = _ref$style2.marginLeft,
    style = _objectWithoutProperties(_ref$style2, _excluded),
    onChange = _ref.onChange,
    onItemClick = _ref.onItemClick,
    gutterLabel = _ref.gutterLabel,
    divider = _ref.divider,
    _ref$labelWrap = _ref.labelWrap,
    labelWrap = _ref$labelWrap === void 0 ? true : _ref$labelWrap,
    isTreeData = _ref.isTreeData,
    className = _ref.className,
    disabled = _ref.disabled;
  var _useHover = (0, _hooksTs.useHover)(),
    _useHover2 = _slicedToArray(_useHover, 2),
    ref = _useHover2[0],
    hovered = _useHover2[1];
  var labelWrapperStyle = gutterLabel ? {
    minWidth: 40
  } : groupItem || !isTreeData ? {} : {
    paddingLeft: 24
  };
  var primaryTooltip = typeof label === 'string' ? label : '';
  var secondaryTooltip = typeof secondaryLabel === 'string' ? secondaryLabel : '';
  var wrapperCyProps = {
    'data-cy': dataCy
  };
  if (groupItem) {
    wrapperCyProps['data-cy-list-group'] = groupItem;
  }
  if (icon) {
    icon = /*#__PURE__*/_react["default"].cloneElement(icon, {
      hovered: hovered
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    style: style
  }, wrapperCyProps), {}, {
    className: (0, _clsx["default"])(className, {
      hovered: hovered
    }),
    ref: ref,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ListItem["default"], {
      component: 'div',
      button: !disabled && (count || !groupItem && button),
      style: {
        height: rowHeight
      },
      divider: divider,
      selected: selected,
      ContainerComponent: 'div',
      onClick: groupItem ? onChange : !disabled ? onItemClick : null,
      actionCount: actionCount,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: labelWrapperStyle,
        children: [icon ? icon : null, checkbox ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemIcon["default"], {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox["default"], {
            edge: 'start',
            checked: checked,
            onClick: function onClick(e) {
              e.stopPropagation();
            },
            onChange: onItemClick,
            tabIndex: -1,
            checkedIcon: isAllChecked || !groupItem ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.CheckBoxIcon, {
              sx: {
                fontSize: 20
              }
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.IndeterminateCheckBoxIcon, {
              sx: {
                fontSize: 20
              }
            }),
            disableRipple: true,
            disabled: !checked && disabled,
            "data-cy-action": dataCyActionCheckbox
          })
        }) : null]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText["default"], {
        primary: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
          direction: 'row',
          spacing: 1,
          alignItems: 'center',
          flex: 1,
          children: [typeof label === 'string' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
            style: groupItem ? {
              fontWeight: 500
            } : {} // TODO: use variant?
            ,
            noWrap: labelWrap,
            variant: 'body1',
            tooltipText: primaryTooltip,
            disableTooltip: !primaryTooltip,
            "data-cy": dataCyTitle,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box["default"], {
              sx: {
                textOverflow: 'ellipsis',
                overflow: 'hidden'
              },
              children: label
            })
          }) : label, groupItem && count ? state.expanded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ArrowDropUpIcon, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ArrowDropDownIcon, {}) : null]
        }),
        secondary: secondaryLabel ? typeof secondaryLabel === 'string' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
          component: 'span',
          noWrap: true,
          variant: 'body2',
          color: 'textSecondary',
          wrapper: true,
          tooltipText: secondaryTooltip,
          disableTooltip: !secondaryTooltip,
          tooltipProps: {
            placement: 'bottom-start'
          },
          children: secondaryLabel
        }) : secondaryLabel : null,
        disableTypography: true
      }), secondaryAction ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemSecondaryAction["default"], {
        "data-cy": dataCyAction,
        children: secondaryAction
      }) : null]
    })
  }));
};
var _default = exports["default"] = RowItem;